"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LiveStreamListResponse = void 0;
var live_stream_1 = require("../metadata/live-stream");
/**
 * Search Live Stream List Response
 * @doc LiveStreamListResponse
 */
var LiveStreamListResponse = /** @class */ (function () {
    function LiveStreamListResponse(data) {
        this.nextPageToken = undefined;
        this.streams = [];
        this.nextPageToken = data.nextPageToken;
        this.streams = data.streams.map(function (liveStream) {
            return new live_stream_1.LiveStream(liveStream);
        });
    }
    return LiveStreamListResponse;
}());
exports.LiveStreamListResponse = LiveStreamListResponse;
//# sourceMappingURL=live-stream-list-response.js.map